<template lang="pug">
pr-wrapper.d-flex(fs, bg)
  .kochealthcare.w-100.h-100
    pr-wrapper.leftside.py-5(bg, zi="1")
      .categories-scope.overflow-hidden(
        v-nv:scope="'categories'",
        data-scroll="center",
        nv-sleep-protect,
        nv-exit-protect,
        @nv-exit="close",
        @nv-back="close",
        data-right="results"
      )
        .scroll-container.position-relative.px-5.py-2
          .option
            pr-text(weight="semibold", size="medium") {{ $t("Categories") }}
            .menu.px-3
              .menu-item(@nv-enter="choose(1)", v-nv)
                pr-text.background(:class="{ 'inactive-element': category === 1 }") {{ $t("Laboratory") }}
              .menu-item(@nv-enter="choose(2)", v-nv)
                pr-text.background(:class="{ 'inactive-element': category === 2 }") {{ $t("Radiology") }} 
              .menu-item(@nv-enter="choose(3)", v-nv)
                pr-text.background(:class="{ 'inactive-element': category === 3 }") {{ $t("Pathology") }} 
              .menu-item(@nv-enter="choose(4)", v-nv)
                pr-text.background(:class="{ 'inactive-element': category === 4 }") {{ $t("Cardiology") }} 
              .menu-item(@nv-enter="choose(6)", v-nv)
                pr-text.background(:class="{ 'inactive-element': category === 6 }") {{ $t("Other Processes") }}
    
    
    pr-wrapper.preloader.align-self-center.m-auto(v-show="!auth || fetching", bg, bgo=".9")
      icon.fa-spin(:icon="'fas spinner'")
    pr-wrapper.preloader.align-self-center.text-center.m-auto(v-show="!fetching && auth && !results.length", bg, bgo=".9")
      pr-text(size="large")
        icon(:icon="'fas user-tag'")
      pr-text.mt-3(size="base") {{ $t("There are no listings to display in this category.") }}

    pr-wrapper.rightside.py-5.overflow-hidden(bg v-show="!fetching && auth && result.length")
      .result-scope.overflow-hidden(
              v-nv:scope="'result'",
              nv-sleep-protect,
              nv-exit-protect,
              @nv-exit="list",
              @nv-back="list",
              @nv-left="list",
              data-left="categories"
              @nv-down="scroll"
              @nv-up="scroll"
              ref="scrollArea"
            )
              .scroll-container.position-relative.px-5.py-2(v-nv)
                .result-item.mb-5(v-for="(image,index) in result" :key="`image-${index}`")
                  img.w-100(:src="`data:image/png;base64,${image}`")
    pr-wrapper.rightside.py-5.overflow-hidden(bg v-show="!fetching && auth && !result.length && results.length")
      .results-header.px-5.pb-4(ref="header")
        .d-flex.flex-column
          pr-subtitle(size="medium") {{ $t("Results") }}
      .results-scope.overflow-hidden(
        v-nv:scope="'results'",
        data-scroll="center",
        nv-sleep-protect,
        nv-exit-protect,
        @nv-exit="close",
        @nv-back="close",
        data-left="categories"
      )
        .scroll-container.position-relative.px-5.py-2(ref="body")
          .option.border.d-flex.background(v-nv, v-for="result in results", :key="result.reportId" @nv-enter="open(result)")
            .description.flex-grow-1.w-50.pr-5
              pr-text.testname(ellipsis size="small") {{ result.title }}
              pr-text.target.font-italic.mt-1(muted, ellipsis, size="small") {{ result.doctor }}
            .status.d-flex.align-items-center.w-25.px-3(v-if="result.status")
              pr-text.alert.border.px-2.py-1.m-auto(ellipsis, size="xsmall") {{ result.status }}
            .times.d-flex.align-items-center.w-25
              .arrival.d-flex.align-items-center
                .icon.mr-2
                  i.fal.fa-calendar-check
                pr-text.time(ellipsis, size="xsmall") {{ $moment(result.date).format("lll") }}
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "kochealthcare",
  data() {
    return {
      category: 1,
      fetching: false,
      result: []
    }
  },
  computed: {
    categories() {
      return {
        1: "laboratoryReports",
        2: "radiologyReports",
        3: "pathologyReports",
        4: "cardiologyReports",
        6: "otherProcessReports"
      }
    },
    selectedCategory() {
      return this.categories[this.category]
    },
    results() {
      return this.reports[this.selectedCategory]
    },
    ...mapGetters("kochealthcare", ["reports", "auth"])
  },
  watch: {
    auth(nval) {
      if (nval) this.fetch()
    }
  },
  async activated() {
    await this.$nextTick()

    _$.nav.sync("categories", true)
    _$.nav.sync("results")
    _$.nav.sync("result")

    if (!this.auth) this.$store.dispatch("kochealthcare/init")
    else this.fetch()
  },
  deactivated() {
    this.$store.commit("kochealthcare/reset")
  },
  methods: {
    close() {
      __.platform.go()
    },
    async choose(code) {
      this.category = parseInt(code)
      await this.fetch()
    },
    async fetch() {
      this.fetching = true

      await this.$store.dispatch("kochealthcare/reports", { type: this.selectedCategory }).finally(() => (this.fetching = false))
      await this.$nextTick()

      if (_$.nav._scopes["results"]) _$.nav._scopes["results"].element.scrollTop = 0
      _$.nav.sync("results")
      return true
    },
    async open(result) {
      this.fetching = true

      const { reportId, reportType } = result
      const res = await this.$store.dispatch("kochealthcare/report", { reportId, reportType }).finally(() => (this.fetching = false))
      if (!res) return

      this.result = res

      await this.$nextTick()
      _$.nav.sync("result", true)

      this.scroll({}, true)
    },
    async list() {
      this.result = []
      _$.nav.changeScope("results", true)
      if (_$.nav._scopes["results"]) _$.nav._scopes["results"].element.scrollTop = 0
    },
    scroll($event, toTop = false) {
      let scrollTop = this.$refs.scrollArea.scrollTop
      switch ($event.type) {
        case "nv-down":
          scrollTop += 200
          break
        case "nv-up":
          scrollTop -= 200
          break
      }
      if (toTop) scrollTop = 0
      $(this.$refs.scrollArea).animate({ scrollTop: scrollTop }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.kochealthcare {
  display: flex;

  .rightside {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: unset;
    position: relative;
    box-shadow: 5px 0 15px 2px rgba(0, 0, 0, 0.25);
    z-index: 1;
    flex-grow: 1;

    .result-scope {
      .result-item {
        img {
          width: 100%;
          border-radius: 10px;
        }
      }
    }
    .results-scope {
      .option {
        padding: 10px 15px;
        margin-bottom: 10px;

        .description {
        }
      }
    }
  }

  .leftside {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: unset;
    box-shadow: 5px 0 15px 2px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 2;

    .categories-scope {
      .option {
        .menu {
          .menu-item {
            margin: 10px 0;

            .background {
              padding: 10px 15px;
            }

            &.nv-el-current {
              .background {
                border-radius: 5px;
              }
            }
            .inactive-element {
              border-radius: 5px;
              padding: 10px 15px;
            }
          }
        }
      }
    }
  }
}
</style>
